/**
 * Persists "ask me later" decisions for permission soft-prompts.
 * Storage can be unavailable (private mode, blocked site data) — every access
 * is guarded so a failure simply means "not snoozed".
 */
export const DAY_MS = 24 * 60 * 60 * 1000;

export function isSnoozed(key: string): boolean {
  try {
    return Number(localStorage.getItem(key) ?? 0) > Date.now();
  } catch {
    return false;
  }
}

export function snooze(key: string, durationMs: number): void {
  try {
    localStorage.setItem(key, String(Date.now() + durationMs));
  } catch {}
}

export function clearSnooze(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {}
}
